import { render, staticRenderFns } from "./ControlloAlloggiRicercaStanzeView.vue?vue&type=template&id=749efed6&"
import script from "./ControlloAlloggiRicercaStanzeView.vue?vue&type=script&lang=ts&"
export * from "./ControlloAlloggiRicercaStanzeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports